<template>
  <div id="reportsByConceptComponent">
  <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout>
        <v-flex class="text-sm-right">
          <v-btn v-if="conceptos.length > 0" @click="reporte" :loading="loadingDownload" round outline color="primary" dark class="text-xs-center">
            <v-icon left>cloud_download</v-icon>
            {{ $t('general.downloadReport') }}
          </v-btn>
          <v-btn v-if="conceptos.length > 0" round outline color="primary" dark @click="downloadZipDialog = true" class="text-xs-center">
          <v-icon left>get_app</v-icon>
          {{$t('general.downloadExpensesFiles')}}
        </v-btn>
        </v-flex>
      </v-layout>
      <v-layout style="padding-bottom: 10px;">
        <v-flex class="ml-2" xs2>
          <v-select v-model="state" :items="status" :label="$t('general.expenseStatus')" class="fixed-height" item-value="id" item-text="name" clearable solo>
            <template slot="selection" slot-scope="data">
              {{ data.item.id === -1 ? data.item.name : $t('expenses.' + data.item.name)}}
            </template>
            <template slot="item" slot-scope="data">
              {{ data.item.id === -1 ? data.item.name : $t('expenses.' + data.item.name)}}
            </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-model="selectedCategory" :items="categories" :label="$t('general.categories')" class="fixed-height" item-text="name" item-value="id" clearable solo></v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-model="project" :items="projects" class="fixed-height" item-value="id" item-text="name" label="Proyectos" clearable  solo>
            <template slot="item" slot-scope="data">
              {{ data.item.name }} - {{ data.item.status === 1 ? $t('projects.stat.active') : $t('projects.stat.inactive')}}
            </template>
            <template v-slot:selection="{ item }">
              <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-select v-model="areaC" :items="areas" item-value="id" class="fixed-height" item-text="name" label="Areas" clearable solo></v-select>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-select v-model="selectedEmployee" :items="employees" :label="$t('expenseDetailEmployee.employee')" class="fixed-height" item-text="name" item-value="id" clearable  solo>
             <template v-slot:selection="{ item }">
              <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="text-xs-center" sm2>
          <v-menu v-model="menuP" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="startDate" :rules="rules.required" :label="$t('employerReports.startDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker color="primary" :max="finishDate" v-model="startDate" @input="menu = false" :locale="$t('reportsByConcept.local')"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex class="text-xs-center" sm2>
          <v-menu v-model="menuP2" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="finishDate" :rules="rules.required" :label="$t('employerReports.endDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker color="primary" v-model="finishDate" @input="menu2 = false" :max="new Date().toISOString().substr(0, 10)" :min="startDate" :locale="$t('reportsByConcept.local')"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-btn @click="getReport" :loading="loadingDownload" color="primary" round>
          <v-icon>search</v-icon> 
          {{$t('general.search')}}
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchReport"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
      </v-layout>
      <v-layout v-if="loadingItems">
        <v-flex>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          <span>{{$t('general.loadingText')}}</span>
        </v-flex>
      </v-layout>
      <v-data-table
        v-if="!loadingItems"
        :search="searchReport"
        :headers="headers"
        :items="conceptos"
        :loading="loadingItems"
        class="elevation-3"
        :pagination.sync="pagination"
        hide-actions
        :no-data-text="$t('expenseDetailEmployee.noResults')"
      >
        <template v-slot:no-data v-if="conceptos.length > 0">
          <center class="title font-weight-light">{{$t('general.noDataText')}}</center>
        </template>
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc',header.value === pagination.sortBy ? 'active' : '']"
              :style="header.hidden ? 'display: none;' : ''"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr style="border-bottom: none;">
            <td class="d-none">{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.date }}</td>
            <td class="text-xs-center">{{ $t('expenses.' + props.item.gst_expenses.status_expense.name) }}</td>
            <td class="text-xs-center d-none">{{ props.item.uuid }}</td>
            <td class="text-xs-center d-none">{{ props.item.description }}</td>
            <td class="text-xs-center">{{ props.item.gst_categories !== null ? props.item.gst_categories.name : '' }}</td>
            <td class="text-xs-center">{{ props.item.subtotal | formatCurrency }}</td>
            <td class="text-xs-center">{{ impuestos(props.item) | formatCurrency }}</td>
            <td class="text-xs-center">{{ props.item.total | formatCurrency }}</td>
            <td class="text-xs-center">{{ props.item.currency_sat !== null ? props.item.currency_sat.c_Moneda : '- -' }}</td>
            <td class="text-xs-center">{{ props.item.exchange }}</td>
            <td class="text-xs-center">{{ (+totalAbsoluto(props.item)) + (props.item.total_amount_tip && props.item.total_amount_tip > 0 ? +props.item.total_amount_tip : +0) | formatCurrency }}</td>
            <td class="text-xs-center">{{ props.item.gst_expenses.user.name }}</td>
            <td class="text-xs-center">{{ props.item.gst_expenses.user.area[0].name }}</td>
          </tr>
          <tr>
            <td colspan="5">
              <span v-if="props.item.uuid">
                <strong>
                  {{ $t('reportsByConcept.UUID') }}:
                </strong>
                {{ props.item.uuid }}
                <br>
              </span>
              <span>
                <strong>
                  {{ $t('reportsByConcept.expenseC') }}:
                </strong>
                <span v-html="props.item.description"></span>
              </span>
            </td>
            <td colspan="2">
              <span v-if="props.item.total_amount_tip && props.item.total_amount_tip > 0">
                <strong>
                  {{ $t('expenses.tip') }}:
                </strong>
                {{ props.item.total_amount_tip | formatCurrency }}
                <br>
              </span>
            </td>
          </tr>
        </template>
        <template v-slot:footer>
          <td class="text-xs-center">
            <strong> {{ $t('general.totalExpenses') }} </strong>
          </td>
          <td class="text-xs-center d-none">
            <strong> </strong>
          </td>
          <td class="text-xs-center d-none">
            <strong> </strong>
          </td>
          <td class="text-xs-center d-none">
            <strong> </strong>
          </td>
          <td class="text-xs-center">
            <strong> </strong>
          </td>
          <td class="text-xs-center">
            <strong> </strong>
          </td>
          <td class="text-xs-center">
            <strong> {{subtotal | formatCurrency}} </strong>
          </td>
          <td class="text-xs-center">
            <strong> {{impuestost | formatCurrency}} </strong>
          </td>
          <td class="text-xs-center">
            <strong> {{total | formatCurrency}} </strong>
          </td>
          <td class="text-xs-center">
            <strong> </strong>
          </td>
          <td class="text-xs-center">
            <strong>  </strong>
          </td>
          <td class="text-xs-center">
            <strong> {{totalCalculado | formatCurrency}} </strong>
          </td>
          <td class="text-xs-center">
            <strong></strong>
          </td>
          <td class="text-xs-center">
            <strong></strong>
          </td>
        </template>
      </v-data-table>
      <div justify="center">
        <v-pagination
          v-model="page"
          :length.sync="pageCount"
          :total-visible="7"
        ></v-pagination>
      </div>
      <v-dialog
        v-model="downloadZipDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('general.downloadExpensesFiles')}}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form
              ref="valDownload"
              lazy-validation
              >
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                    :items="zipsAvailables"
                    item-value="month"
                    v-model="selectedZip"
                    :label="$t('general.availableFiles')"
                    return-object
                    :rules="rules.required"
                    required
                  >
                    <template slot="selection" slot-scope="data">
                      ({{startDate.substr(0, 4) + '-' + data.item.month}}) {{$t('general.expensesFiles')}}
                    </template>
                    <template slot="item" slot-scope="data">
                      ({{startDate.substr(0, 4) + '-' + data.item.month}}) {{$t('general.expensesFiles')}}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              round
              @click="closeDownloadDialog"
            >{{$t('general.close')}}</v-btn>
            <v-btn
              color="primary"
              depressed
              round
              @click="downloadFiles()"
              :loading="loading"
              :disabled="loading"
            >{{$t('general.download')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'reportsByConceptComponent',
  data () {
    return {
      startDate: new Date().toISOString().substr(0, 8) + '01',
      finishDate: new Date().toISOString().substr(0, 10),
      searchReport: '',
      valid: true,
      subtotal: 0,
      impuestost: 0,
      total: 0,
      state: null,
      areaC: null,
      project: null,
      selectedCategory: null,
      company_id: null,
      companyId: null,
      selectedEmployee: null,
      loading: false,
      loadingItems: true,
      switchAllStatus: true,
      switchAllAreas: true,
      switchAllCategories: true,
      switchAllProyects: true,
      switchAllEmployees: true,
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 25, // -1 for All",
        pageCount: 0,
        itemsLength: 0
      },
      serverItemsLength: 178,
      page: 1,
      pageCount: 0,
      options: {
        itemsPerPage: 25
      },
      dialog: false,
      itemsPerPage: 25,
      projects: [],
      areas: [],
      categories: [],
      employees: [],
      concepts: [],
      conceptos: [],
      status: [],
      menu: false,
      menu2: false,
      menuP: false,
      menuP2: false,
      downloadZipDialog: false,
      show: false,
      detailedData: [],
      expensesItems: null,
      selectedZip: null,
      valDownload: true,
      loadingDownload: false
    }
  },
  computed: {
    heading () {
      return this.$t('reportsByConcept.name')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-file-alt fa-fw icon-color'
    },
    headers () {
      return [
        {
          text: this.$t('reportsByConcept.id'),
          align: 'center',
          value: 'concepts',
          sortable: true,
          hidden: true
        },
        {
          text: this.$t('reportsByConcept.date'),
          align: 'center',
          value: 'date',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.state'),
          align: 'center',
          value: 'status_expense.name',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.UUID'),
          align: 'center',
          value: 'uuid',
          sortable: true,
          hidden: true
        },
        {
          text: this.$t('reportsByConcept.expenseC'),
          align: 'center',
          value: 'description',
          sortable: true,
          hidden: true
        },
        {
          text: this.$t('reportsByConcept.category'),
          align: 'center',
          value: 'gst_categories.name',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.subtotal'),
          align: 'center',
          value: 'subtotal',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.taxes'),
          align: 'center',
          value: 'tax',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.originalT'),
          align: 'center',
          value: 'total',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.currency'),
          align: 'center',
          value: 'currency',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.exchange_rate'),
          align: 'center',
          value: 'exchange',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.total'),
          align: 'center',
          value: 'total',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.madeExpense'),
          align: 'center',
          value: 'user.name',
          sortable: true
        },
        {
          text: this.$t('reportsByConcept.area'),
          align: 'center',
          value: 'user.area[0].name',
          sortable: true
        }
      ]
    },
    rules () {
      return {
        required: [v => !!v || this.$t('validation.required')]
      }
    },
    totalCalculado () {
      let computedTotal = 0
      this.conceptos.forEach(element => {
        let totalAbs = this.totalAbsoluto(element)
        computedTotal += +totalAbs
      })
      return computedTotal
    },
    zipsAvailables () {
      if (this.expensesItems && this.expensesItems.length > 0) {
        let startMonth = this.startDate.substr(5, 2)
        let endMonth = this.finishDate.substr(5, 2)
        let filtro = this.expensesItems.filter(item => item.month >= startMonth && item.month <= endMonth)
        return filtro
      }
    }
  },
  created () {
    this.initialize()
    this.getReport()
  },
  watch: {
    concepts () {
      if (this.concepts !== undefined) {
        this.conceptos = []

        if (this.concepts.length > 0) {
          this.concepts.forEach(element => {
            if (element.gst_expenses_items !== undefined) {
              element.gst_expenses_items.forEach(item => {
                item.status_expense = element.status_expense
                item.user = element.user
                item.workflow = element.workflow
                this.conceptos.push(item)
              })
            }
          })
        }
      }
      this.totalT()
      this.subtotalT()
      this.impuestosT()
    },
    '$store.state.userLogged' () {
      this.initialize()
      this.getReport()
    },
    switchAllStatus () {
      if (this.switchAllStatus) {
        this.state = null
      }
    },
    switchAllAreas () {
      if (this.switchAllAreas) {
        this.areaC = null
      }
    },
    switchAllProyects () {
      if (this.switchAllProyects) {
        this.project = null
      }
    },
    switchAllCategories () {
      if (this.switchAllCategories) {
        this.selectedCategory = null
      }
    },
    switchAllEmployees () {
      if (this.switchAllEmployees) {
        this.selectedEmployee = null
      }
    },
    page () {
      this.conceptos = []
      this.loadingItems = true
      this.getReport()
    }
  },
  methods: {
    initialize () {
      if (this.$store.state.userLogged !== null && this.$store.state.userLogged.company !== undefined) {
        this.$emit('initialize', {
          context: this,
          company_id: this.$store.state.userLogged.company[0].id,
          item: {
            companyId: this.$store.state.userLogged.company[0].id
          }
        })
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    send () {
      if (this.$refs.form.validate()) {
        this.loadingDownload = true
        this.getReport()
      }
    },
    getReport () {
      this.loading = true
      if (this.$store.state.userLogged.company) {
        this.$emit('send', {
          company_id: this.$store.state.userLogged.area[0].company_id,
          date_start: this.startDate,
          date_end: this.finishDate,
          area_id: this.areaC,
          project_id: this.project,
          status_id: this.state,
          category_id: this.selectedCategory,
          employee_id: this.selectedEmployee,
          type: 'json',
          context: this
        })
      }
    },
    search () {
      this.getReport()
    },
    close () {
      // close the dialog and re-assing default values
      this.switchAllStatus = true
      this.switchAllAreas = true
      this.switchAllProyects = true
      this.switchAllCategories = true
      this.switchAllEmployees = true
      this.loading = false
      this.dialog = false
      this.$refs.form.resetValidation()
    },
    resetForm () {
      // this.$refs.form.reset()
      // this.concepts = []
      // this.conceptos = []
    },
    validate (fecha) {
    },
    area (items) {
      let area = ''
      if (items) {
        area = items.area.name
      }
      return area
    },
    impuestos (items) {
      let impuesto = 0
      let total = 0
      let subtotal = 0
      if (items) {
        total = parseFloat(items.total).toFixed(2)
        subtotal = parseFloat(items.subtotal).toFixed(2)
        impuesto = (total - subtotal).toFixed(2)
      }
      return impuesto
    },
    totalAbsoluto (items) {
      let totalAbsoluto = 0
      let impuestos = 0
      let subtotal = 0
      let total = 0
      let final = 0
      let exchange = 0
      if (items) {
        exchange = parseFloat(items.exchange)
        if (exchange !== 1) {
          total = parseFloat(items.total).toFixed(2)
          subtotal = parseFloat(items.subtotal).toFixed(2)
          impuestos = parseFloat(total - subtotal).toFixed(2)
          final = parseFloat(subtotal + impuestos).toFixed(2)
          totalAbsoluto = parseFloat(final * total).toFixed(2)
        } else {
          totalAbsoluto = parseFloat(items.total).toFixed(2)
        }
      }
      return totalAbsoluto
    },
    totalT () {
      let suma = 0
      this.conceptos.forEach(gastos => {
        if (gastos.total === null) {
          gastos.total = 0
        }
        suma += parseFloat(gastos.total)
      })
      this.total = suma.toFixed(2)
    },
    subtotalT () {
      let suma = 0
      this.conceptos.forEach(gastos => {
        if (gastos.subtotal === null) {
          gastos.subtotal = 0
        }
        suma += parseFloat(gastos.subtotal)
      })
      this.subtotal = suma.toFixed(2)
    },
    impuestosT () {
      this.impuestost = parseFloat(this.total - this.subtotal).toFixed(2)
    },
    reporte () {
      this.loadingDownload = true
      this.$emit('downloadReport', {
        company_id: this.$store.state.userLogged.area[0].company_id,
        date_start: this.startDate,
        date_end: this.finishDate,
        area_id: this.areaC,
        project_id: this.project,
        status_id: this.state,
        category_id: this.selectedCategory,
        employee_id: this.selectedEmployee,
        type: 'download',
        context: this
      })
    },
    closeDownloadDialog () {
      this.downloadZipDialog = false
      this.selectedZip = null
    },
    downloadFiles () {
      if (this.$refs.valDownload.validate()) {
        this.$emit('downloadFiles', {
          context: this,
          expensesItems: this.selectedZip,
          date: this.startDate.substr(0, 4)
        })
        this.loading = true
      }
    },
    dateFormat (date) {
      let formatted = date.replace(/-/g, '/')
      return formatted
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/reportsbyconcept.component.vue